import { call, put, all, takeLatest } from "redux-saga/effects";
import { Api } from "../api";
import * as dashboardActions from "../actions/dashboard";

// function* getHeaderMenuList(action) {
//   try {
//     const res = yield call(Api.dashboard.getHeaderMenuList, action.payload);
//     yield put({
//       type: dashboardActions.GET_HEADER_MENU_LIST_SUCCESS,
//       payload: res.data.result.data,
//     });
//   } catch (err) {
//     yield put({
//       type: dashboardActions.GET_HEADER_MENU_LIST_FAIL,
//       payload: { error: err.message },
//     });
//   }
// }

function* getScopeYears(action) {
  try {
    const res = yield call(Api.dashboard.getScopeYears, action.payload);
    yield put({
      type: dashboardActions.GET_SCOPE_YEARS_SUCCESS,
      payload: res.data.result.data,
    });
  } catch (err) {
    yield put({
      type: dashboardActions.GET_SCOPE_YEARS_FAIL,
      payload: { error: err.message },
    });
  }
}

function* getExchangeSystems(action) {
  try {
    const res = yield call(Api.dashboard.getExchangeSystems, action.payload);
    yield put({
      type: dashboardActions.GET_EXCHANGE_SYSTEMS_SUCCESS,
      payload: res.data.result.data,
    });
  } catch (err) {
    yield put({
      type: dashboardActions.GET_EXCHANGE_SYSTEMS_FAIL,
      payload: { error: err.message },
    });
  }
}

function* getRegion(action) {
  try {
    const res = yield call(Api.dashboard.getRegion, action.payload);
    yield put({
      type: dashboardActions.GET_REGION_SUCCESS,
      payload: res.data.result.data,
    });
  } catch (err) {
    yield put({
      type: dashboardActions.GET_REGION_FAIL,
      payload: { error: err.message },
    });
  }
}

function* getData(action) {
  try {
    // const systemCount = yield call(
    //   Api.dashboard.getSystemCount,
    //   action.payload
    // );
    const activities = yield call(
      Api.dashboard.getActivities,
      action.payload
    );
    const sites = yield call(Api.dashboard.getSites, action.payload);
    const fieldTasks = yield call(
      Api.dashboard.getFieldTasks,
      action.payload
    );
    const forecast = yield call(Api.dashboard.getForecasts, action.payload);
    const bts = yield call(Api.dashboard.getBTS, action.payload);
    const contracts = yield call(Api.dashboard.getContracts, action.payload);
    const permits = yield call(Api.dashboard.getPermits, action.payload);
    const invoices = yield call(Api.dashboard.getInvoices, action.payload);

    yield put({
      type: dashboardActions.GET_SITES_SUCCESS,
      payload: sites.data.result.data,
      name: 'sites',
    });
    yield put({
      type: dashboardActions.GET_ACTIVITIES_SUCCESS,
      payload: activities.data.result.data,
      name: 'activities',
    });
    yield put({
      type: dashboardActions.GET_FIELD_TASKS_SUCCESS,
      payload: fieldTasks.data.result.data,
      name: 'fieldTasks',
    });
    yield put({
      type: dashboardActions.GET_FORECASTS_SUCCESS,
      payload: forecast.data.result.data,
      name: 'forecast',
    });
    yield put({
      type: dashboardActions.GET_BTS_SUCCESS,
      payload: bts.data.result.data,
      name: 'bts',
    });
    yield put({
      type: dashboardActions.GET_CONTRACTS_SUCCESS,
      payload: contracts.data.result.data,
      name: 'contracts',
    });
    yield put({
      type: dashboardActions.GET_PERMITS_SUCCESS,
      payload: permits.data.result.data,
      name: 'permits',
    });
    yield put({
      type: dashboardActions.GET_INVOICES_SUCCESS,
      payload: invoices.data.result.data,
      name: 'invoices',
    });
    yield put({
      type: dashboardActions.LOAD_DATA_SUCCESS,
    });
  } catch (err) {
    // yield call(errorHandler, err);
    yield put({
      type: dashboardActions.LOAD_DATA_FAIL,
      payload: { error: err.message },
    });
  }
}


export default all([
  takeLatest(dashboardActions.GET_SCOPE_YEARS_REQUEST, getScopeYears),
  takeLatest(dashboardActions.GET_REGION_REQUEST, getRegion),
  takeLatest(dashboardActions.GET_EXCHANGE_SYSTEMS_REQUEST, getExchangeSystems),
  takeLatest(dashboardActions.LOAD_DATA_REQUEST, getData),
  ]
);
